var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"VariationSelector",style:({ backgroundColor: _vm.unselectedColor,
                     color: _vm.titleColor }),on:{"click":_vm.handleClick}},[_c('div',{staticClass:"Title",style:({ backgroundColor: _vm.titleBackground })},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }